import { useState } from 'react';
import { postPaymentLink } from 'services/orders';
import { displayErrorNotification, displaySuccessNotification } from 'utils/displayNudosStandardNotifications';

export const useRegisterOrderPaymentLink = () => {
  const [isLoading, setIsLoading] = useState(false);

  const register = async (orderId: number, paymentLink: string): Promise<boolean> => {
    setIsLoading(true);
    try {
      if (!paymentLink.trim()) {
        displayErrorNotification({ customJSXMessage: <>El link de pago es obligatorio</> });
        return false;
      }
      const body = { paymentLink: paymentLink.trim() };
      await postPaymentLink(orderId, body);
      displaySuccessNotification({ customJSXMessage: <>Se han guardado los cambios</> });
      return true;
    } catch (error) {
      displayErrorNotification();
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, register };
};
